// removed by extract-text-webpack-plugin
module.exports = {"productNameText":"productNameText__guO_l","productText":"productText__1eGX0","productSliderContainer":"productSliderContainer__27Tgt","productDetailsContainer":"productDetailsContainer__3-nYH","outerProductDetailsContainer":"outerProductDetailsContainer__D9j4p","shopNowText":"shopNowText__1LW_D","productIcon":"productIcon__1QjFE"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-preapproved-success/components/campaignLandingProductSection/productSlider/style.css
// module id = WcHs
// module chunks = 458